import React from 'react';
import { Box, TextField, InputAdornment, Chip, alpha, useTheme, useMediaQuery } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

interface CalendarHeaderProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  eventCount: number;
}

export const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  searchTerm,
  onSearchChange,
  eventCount
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{
      mb: 1.5,
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      gap: 1.5,
      alignItems: isMobile ? 'stretch' : 'center'
    }}>
      <TextField
        placeholder="Search appointments..."
        size="small"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{
          width: isMobile ? '100%' : 320,
          '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
            bgcolor: alpha(theme.palette.action.hover, 0.01),
            '& fieldset': { borderColor: alpha(theme.palette.divider, 0.5) },
            '&:hover fieldset': { borderColor: theme.palette.primary.main },
          }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" color="action" />
            </InputAdornment>
          ),
        }}
      />
      {!isMobile && (
        <Chip
          label={`${eventCount} appointment${eventCount !== 1 ? 's' : ''}`}
          size="small"
          variant="outlined"
          sx={{ ml: 'auto', fontWeight: 600, borderRadius: '8px' }}
        />
      )}
    </Box>
  );
};
